import React from 'react'
import PropTypes from 'prop-types'
import Plot from 'react-plotly.js'
import * as utils from '../../utils/commonLayout'

class ScatterPlot extends React.Component {
    static propTypes = {
        data: PropTypes.array,
        mapWidth: PropTypes.number,
        selectedGenre: PropTypes.string,
        isOpen: PropTypes.bool.isRequired
    }

    constructor (props) {
        super(props);
        this.state = {
            data: this.props.data,
            layout: null,
            config: {
                responsive: true,
                displaylogo: false,
                modeBarButtonsToRemove: ['toImage', 'autoScale2d', 'toggleSpikelines', 'hoverCompareCartesian', 'hoverClosestCartesian']
            },
            annotations: []
         }
    }

    componentDidMount () {
        this.setState({data: this.props.data})
        this.setData()
    }

    componentDidUpdate (prevProps) {
      if (prevProps.selectedGenre !== this.props.selectedGenre || prevProps.isOpen !== this.props.isOpen) {
        this.setData()
      }
    }

    setData = () => {
        this.setState({
            layout: {
                width: this.props.mapWidth,
                height: window.innerHeight - 110,
                autosize: true,
                margin: {l: 10, r: 10, b: 30, t: 40},
                hovermode: 'closest',
                // hoverlabel: { bgcolor: '#FFF' },
                legend: {orientation: 'h', y: -0.3},
                xaxis: {
                    showgrid: true,
                    zeroline: false,
                    visible: false,
                    automargin: true
                },
                yaxis: {
                    showgrid: true,
                    zeroline: false,
                    visible: false,
                    automargin: true
                },
                template: utils.template_plotly
            }
        })
    }

    render () {
        return ((this.props.data && this.state.layout) &&
          <Plot
            data={this.props.data}
            layout={this.state.layout}
            config={this.state.config}
            useResizeHandler
            style={{ width: '100%', height: '100%' }}
            onInitialized={(figure) => this.setState(figure)}
            onUpdate={(figure) => this.setState(figure)}
            />
        )
    }
}

export default ScatterPlot;